const InfiniteProgress = (props) => {
    return (
        <div className="progress" style={{height:40}}>
            <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{ width: "100%" }}>
                {props?.text ? props.text : null}
            </div>
        </div>
    );
}

export default InfiniteProgress;